import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    lang: 1
};
export const LangSlice = createSlice({
    initialState,
    name: 'lang',
    reducers: {
        changeLang: (state, action) => {
            state.lang = action.payload;
        }
    }
});
export default LangSlice.reducer;
